/**
 * Auth store: token JWT + datos básicos del usuario, persistido en localStorage.
 */

import { create } from "zustand";
import { persist, createJSONStorage } from "zustand/middleware";

import type { UserOut } from "@/types/api.ts";

interface AuthState {
  token: string | null;
  user: UserOut | null;
  setSession: (token: string, user: UserOut) => void;
  clearSession: () => void;
}

export const useAuthStore = create<AuthState>()(
  persist(
    (set) => ({
      token: null,
      user: null,
      setSession: (token, user) => set({ token, user }),
      clearSession: () => set({ token: null, user: null }),
    }),
    {
      name: "sistema-sale-pos.auth",
      storage: createJSONStorage(() => localStorage),
    },
  ),
);
